/**
 * HE.FaIcon
 */

(function FaIcon($, HE)
{
	"use strict";

	// HE.Icons mapping happens in core _hotelengine.js, see comments there
	var faIcon = {};

	// returns a style string to use used for class manipulation
	// returns: 'fas fa-your-face'
	faIcon.getIconStyle = function getIconStyle(name, style) {
		var icon  = HE.Icons[name];
		var _style;

		// use icon default
		if (icon === undefined) {
			throw new Error('Undefined HE.Icon - ' + name + '. Please add to HtmlComponent->icons mapping.');
		}

		if (style === undefined) {
			_style = icon.prefix;
		} else {
			_style = HE.Icons.style[style];

			if (_style === undefined) {
				throw new Error('Undefined HE.Icon style - ' + style);
			}
		}

		return _style+' '+icon.class;
	};

	// returns a full selector string for a fontawesome icon
	// returns: '.fas .fa-your-face'
	faIcon.getIconSelector = function getIconSelector(name, style) {
		var icon = faIcon.getIconStyle(name, style);
		return '.'+icon.replace(' ', ' .');
	};

	// returns just the class name of the icon without the style prefix,
	// as a selector, to be used for jquery selector stuff (eg. $el.find())
	// returns: '.fa-your-face'
	faIcon.getIconSelectorName = function getIconSelectorName(name) {
		var icon = faIcon.getIconSelector(name);
		return icon.split(' ')[1];
	};

	// returns just the class name of the icon without the style prefix,
	// to be used to jquery class manipulation (eg. $el.addClass())
	// returns: 'fa-your-face'
	faIcon.getIconStyleName = function getIconStyleName(name) {
		var icon = faIcon.getIconStyle(name);
		return icon.split(' ')[1];
	};


	HE.FaIcon = faIcon;
}(jQuery, window.HE || {}));
